<template>
<el-row>
  <el-form :model="register" :rules="RegisterRules" ref="loginForm" label-position="left" label-width="0px"
           class="demo-ruleForm login-container">
    <h3 class="title">Fast SignUp!</h3>
    <el-form-item prop="account">
      <i class="el-icon-phone">Account</i>
      <el-input id="account" type="email" v-model="register.account" auto-complete="off" placeholder="Account"></el-input>
    </el-form-item>
    <el-form-item prop="checkPass">
      <i class="el-icon-view">Password</i>
      <el-input type="password" v-model="register.checkPass" auto-complete="off" show-password placeholder="Password"></el-input>
    </el-form-item>
     <el-button @click.native.prevent="signup" type="primary" class="loginBtn2">Sign up
      </el-button>
  </el-form>
  <v-layout class="showgoods">
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img
          class="white--text"
          height="200px"
          src="https://cdn.vuetifyjs.com/images/cards/docks.jpg"
        >
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline">Why SignUp?</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <span class="grey--text">Better experience</span><br>
            <span>Free online submit</span><br>
            <span>Know more friends</span>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="orange">Become our supporter</v-btn> 
          <v-btn flat color="orange">Explore</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</el-row>
</template>

<script>
import firebase from 'firebase';
import store from '../store.js'
import '@/components/icon.css'

  export default {
    name:'Register',
    methods: {
signup: function(e) {
firebase
.auth()
.createUserWithEmailAndPassword(this.register.account, this.register.checkPass)
.then(
user => {
  alert('successful register!');
  this.$router.go({path: this.$router.path});
},
err => {
  alert(err.message);
}
);
e.preventDefault();
}   
  },
    data(){
      return {
        logining: false,
        register: {
          account: 'email',
          checkPass: 'password'
         },
        RegisterRules: {
          account: [
            {required: true, message: 'please type your account', trigger: 'blur'},
          ],
          checkPass: [
            {required: true, message: 'please type your password', trigger: 'blur'},
          ]
         },
        checked: true 
       }
     },
  }
</script>

<style lang="scss" scoped>
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 80px auto;
    max-width: 600px;
    width: auto;
    padding: 35px 35px 45px 35px;
    border: 1px solid #050505;
    background: #2aa6f89d;
    color: #fff;
  }
  .title {
    width: 100%;
    margin: 0px auto 40px auto;
    text-align: center;
  }
 
  .loginBtn {
    width: 100%;
    font-size: 20px;
    letter-spacing: 10px;
  }
  .loginBtn2 {
    width: 100%;
    margin-top: 10px;
    font-size: 20px;
    letter-spacing: 10px;
  }
  .showgoods{
  margin: 10px auto;
  }

</style>
